import { memo, useEffect } from 'react'
// components
import Header from './header/Header'
import Main from './main/Main'
import Sidebar from './sidebar/Sidebar'

import { useAppDispatch } from '../hooks/useStore'
import useWindowDimensions from '../hooks/useWindowDimensions'
import { toggleSidebar } from '../store/features/dashboardUi/dashboardUiSlice'
import Routing from '../routes'

const Layout = () => {
  const dispatch = useAppDispatch()

  const { width } = useWindowDimensions()

  useEffect(() => {
    if (width < 1024) {
      dispatch(toggleSidebar(false))
    }
    return () => {
      dispatch(toggleSidebar(false))
    }
  }, [width])

  return (
    <>
      <div className='flex mt-16 fixed top-0 right-0 w-full min-h-[calc(100vh-4rem)]'>
        <Header />
        <Sidebar />
        <Main>
          <Routing />
        </Main>
      </div>
    </>
  )
}

export default memo(Layout)
